import { AddUsersToMultipleTagsCardShared } from '@scale/genai-compass-shared/cards/add_users_to_multiple_tags';
import { makeAutoOpsCardUI } from '../constants';
import { faUserTag } from '@fortawesome/pro-solid-svg-icons';

export const AddUsersToMultipleTagsCardUI = makeAutoOpsCardUI(AddUsersToMultipleTagsCardShared, {
  button: { icon: faUserTag },
  isLegacy: true,
  ownerTeam: 'Pay / Growth',
});
